import { Locale } from '../../Entities/Locale/Locale.entity';
import { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';

export const navigateToCheckout = (
  router: any,
  locale: Locale,
  vehicle: Vehicle,
  hasHeyCarConnect: boolean,
  hasDealerCash: boolean,
  hasVtiCash: boolean,
): boolean => {
  const checkoutId = `${locale}/checkout/${vehicle.heycarId}`;
  if (hasHeyCarConnect) {
    router?.push(`/${checkoutId}/connect/about-you`);
    return true;
  }
  if (hasDealerCash) {
    router?.push(`/${checkoutId}/dealer-cash/about-you`);
    return true;
  }
  if (hasVtiCash) {
    router?.push(`/${checkoutId}/vti-cash/about-you`);
    return true;
  }
  return false;
};
